import { call, put, takeEvery } from 'redux-saga/effects';
import axios from 'axios';
import { REQUEST, fetchSuccess, fetchFailure } from '../../actions/discovery/toggleAlert';
import config from '../../../config';
import { getLocalUser } from '../../../utils/localUser';
import { extractErrorMessage } from '../../../utils/apiResponseHandler';

function* operation(action) {
  const { goalId, alertId, enabled } = action?.payload || {};
  try {
    yield call(
      axios.put,
      `${config.API_URL}/goals/${goalId}/alerts/${alertId}`,
      { enabled },
      { headers: getLocalUser() },
    );
    yield put(fetchSuccess({ alertId, enabled, at: Date.now() }));
  } catch (error) {
    // The panel toggles optimistically and simply reloads the list to
    // revert on failure — no global error surface, matching the
    // previous inline behavior.
    yield put(fetchFailure(extractErrorMessage(error)));
  }
}

export function* watch() {
  // takeEvery: rapid toggles across different rules must all land.
  yield takeEvery(REQUEST, operation);
}
